import {
  Button,
  Divider,
  FormControl,
  Grid,
  Icon,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import {
  dateSelectorWithTopLabel,
  selectWithTopLabel,
  timepickerWithTopLabel,
} from '../../uiComponent';
import FHIRPatient from '../Patient/fhirPatient';
import FHIRPatientContext from '../Patient/fhirPatientConext';
import SearchPatient from './fetchPatients';
import { TextFieldWithTopLabelComponent } from '../../uiComponent/fhirComponentUi';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCurrentInvoicePatientObject,
  setReduxCurrentClaimsObject,
} from '../../../../redux/features/currentSlice';
import { isUndefined } from 'lodash';

const PatientSearchPage = props => {
  console.log(`schedule appn`, props);

  const currentReduxClaimsState = useSelector(
    state => state?.current?.currentClaimsObject
  );

  const initialStateFromProps = claimRecord => {
    return {
      patientName: !isUndefined(
        currentReduxClaimsState?.patientObject?.name?.[0]?.text
      )
        ? currentReduxClaimsState?.patientObject?.name?.[0]?.text
        : '',
    };
  };

  const reduxDispatch = useDispatch();

  const [patientState, setPatinetState] = useState(
    initialStateFromProps(props?.claimRecord?.patient?.reference)
  );

  useEffect(() => {
    console.log(`reduxClaimsObject 2`, currentReduxClaimsState);
  }, [currentReduxClaimsState]);

  const [isSearch, setIsSearch] = useState(false);
  const [isPatient, setPatient] = useState(false);
  const [isCreatePatient, setIsCreatePatient] = useState(false);
  //   const [patientObject, setPatientObject] = useState({});

  const onPatientSelectCallback = patientObject => {
    if (props.hasOwnProperty('fromInvoice')) {
      props?.setSelectedPatient(patientObject);
      props?.selectedPatientNew?.splice(0, props?.selectedPatientNew?.length);
      props?.selectedPatientNew.push(patientObject);
    } else {
      reduxDispatch(
        setReduxCurrentClaimsObject({
          ...currentReduxClaimsState,
          patientObject: patientObject,
        })
      );
    }
  };

  useEffect(() => {
    setPatinetState(initialStateFromProps(props?.claimRecord));
  }, [props?.claimRecord]);

  useEffect(() => {
    // console.log(`PTX`, patientState);
  }, [patientState]);

  const handleOnChange = event => {
    const { name, value } = event?.target;
    setPatinetState({
      ...patientState,
      [name]: value,
    });
  };
  const handleOnChangeSearch = event => {
    const { name, value } = event?.target;
    setPatinetState({
      ...patientState,
      [name]: value,
    });
    //setIsSearch(false);
    //setIsSearch(true);
  };

  useEffect(() => {
    setIsSearch(true);
  }, [patientState?.patientName]);
  const handleOnClick = event => {
    setPatient(true);
    setIsSearch(true);
    setIsCreatePatient(true);
  };

  const handleOnCancel = () => {
    setIsSearch(false);
    setIsCreatePatient(false);
  };

  const patientSearchValidationObject = {
    label: 'Patient',
    name: 'patientName',
    value: patientState?.patientName,
    validation: {
      required: true,
    },
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper
            sx={{
              padding: 3,
              margin: 3,
            }}
            style={props?.fromInvoice && { border: '2px solid #5582bc' }}
          >
            <Grid container>
              <Grid container item xs={12} spacing={2}>
                <Grid item xs={6}>
                  <TextFieldWithTopLabelComponent
                    {...patientSearchValidationObject}
                    onChange={handleOnChangeSearch}
                  />
                </Grid>
                <Grid item xs={6}></Grid>
              </Grid>

              <Grid item xs={12}>
                {isSearch && !isCreatePatient && (
                  <SearchPatient
                    wordSearch={patientState?.patientName}
                    setIsSearch={setIsSearch}
                    setIsCreatePatient={setIsCreatePatient}
                    setPatientObject={props?.setPatientObject}
                    selectedPatientNew={props?.selectedPatientNew}
                    setPatinetState={setPatinetState}
                    onPatientSelectCallback={onPatientSelectCallback}
                    hideCancel
                  />
                )}
              </Grid>
              <Grid item xs={12}>
                {isCreatePatient && (
                  <FHIRPatient
                    isEdit={true}
                    patientObject={{}}
                    setIsCreatePatient={setIsCreatePatient}
                    handleOnCallback={() => {}}
                  />
                )}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default PatientSearchPage;
